import {
  CaesarsButton,
  useIsDesktop,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {useTheme, View, Text} from 'native-base';
import React from 'react';
import {Image} from 'react-native';

interface BreadCardModuleProps {
  onPress: () => Promise<void>;
  loading: boolean;
}

const BreadCardModule: React.FC<BreadCardModuleProps> = ({
  onPress,
  loading,
}) => {
  const isDesktop = useIsDesktop();
  const {colors} = useTheme() as any;
  const {white} = colors;
  const cardHeight = isDesktop ? 194 : 226;
  const cardWidth = isDesktop ? 120 : 140;

  return (
    <View
      shadow={isDesktop ? 0 : undefined}
      backgroundColor={white}
      flexDirection={isDesktop ? 'row' : 'column'}
      paddingTop={isDesktop ? undefined : '4px'}
      paddingBottom={isDesktop ? undefined : '32px'}
      paddingX={isDesktop ? undefined : '16px'}
      alignItems={isDesktop ? undefined : 'center'}>
      <View
        flexDirection="row"
        paddingTop={isDesktop ? '16px' : undefined}
        paddingLeft={isDesktop ? '32px' : undefined}
        paddingBottom={isDesktop ? '80px' : undefined}>
        <Image
          style={{
            height: cardHeight,
            width: cardWidth,
          }}
          source={require('../../assets/Caesars_Bread_Visa_Gold.png')}
          alt="Caesars Rewards Visa card. The lower portion of the card is gold, the rest is black."
        />
        <Image
          style={{
            height: cardHeight,
            width: cardWidth,
          }}
          source={require('../../assets/Caesars_Bread_Visa_Black.png')}
          alt="Caesars Rewards Visa card. The bulk of the card is black in color."
        />
      </View>
      <View
        flexDirection="column"
        paddingTop={isDesktop ? '32px' : undefined}
        paddingLeft={isDesktop ? '16px' : undefined}
        paddingRight={isDesktop ? '32px' : undefined}
        paddingBottom={isDesktop ? '32px' : '24px'}
        flex={1}
        alignItems={isDesktop ? undefined : 'center'}>
        <Text
          fontFamily="heading"
          fontWeight={400}
          fontSize={isDesktop ? 32 : 20}
          lineHeight={isDesktop ? '36px' : '24px'}
          textAlign={isDesktop ? undefined : 'center'}>
          Earn Reward Credits on everyday purchases
        </Text>
        <Text
          fontFamily="heading"
          fontWeight={400}
          fontSize={16}
          lineHeight="22px"
          paddingTop="16px"
          paddingX={isDesktop ? undefined : '16px'}
          textAlign={isDesktop ? undefined : 'center'}>
          Play your cards right - earn Reward Credits on everyday purchases,
          unlock annual bonus Tier Credits, and enjoy Platinum status.
        </Text>
        <View
          flex={1}
          justifyContent={'flex-end'}
          paddingTop={isDesktop ? undefined : '16px'}>
          <CaesarsButton
            title="Apply Now"
            onPress={onPress}
            alignSelf="flex-end"
            isLoading={loading}
          />
        </View>
      </View>
    </View>
  );
};

export default BreadCardModule;
